import "./Footer.css";
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* Company Info */}
        <div className="footer-box">
          <h2 className="footer-logo">Urban Brick Real Estate Broking Co.</h2>
          <p>
            Urban Brick Real Estate Broking Co. is a trusted real estate consultancy dedicated to connecting buyers, 
            sellers, and investors with the right property opportunities, offering expert guidance, verified listings,
             and end-to-end support to ensure smooth and successful property transactions.
          </p>

          <div className="footer-social">
            <a 
              href="https://www.facebook.com/UrbanBrickRealEstateBroking" 
              target="_blank" 
              rel="noopener noreferrer"
            >
             <FaFacebookF />
           </a>
            <FaInstagram />
            <FaTwitter />
            <FaLinkedinIn />
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-box">
          <h3>Quick Links</h3>
          <ul>
            <li>Home</li>
            <li>Buy</li>
            <li>Sale</li>
            <li>Rent</li>
            <li>Contact</li>
          </ul>
        </div>

        {/* Property Links */}
        <div className="footer-box">
          <h3>Other Links</h3>
          <ul>
            <li>Careers with us</li>
            <li>Terms & Conditions</li>
            <li>Report a problem</li>
            <li>Privacy Policy</li>
            <li>Grievances</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-box">
          <h3>Contact Info</h3>
          <p>📍Zirakpur  Punjab , 140604</p>
          <p>📧 info@urbanbrick.in.net</p>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>© 2026 Urban Brick Real Estate Broking Co . Designed & Developed by CallTech Global Team ( A Brand of M.Star Services )</p>
      </div>

    </footer>
  );
}

export default Footer;
